const backgroundImageMaxHeightInPx = 600;
const wrapper = "_35sws3mmgk";
const canvas = "_35sc19fthmm";
const inputs = "_35sin9w58m";
const background = "_35sb6k6qhs";

export { background, backgroundImageMaxHeightInPx, canvas, inputs, wrapper };
import "./organism.canvas.style.linaria.module.css";
//# sourceMappingURL=organism.canvas.style.js.map
